import React from 'react';
import styled from '@emotion/styled';
import ReactPlayer from 'react-player';
import { AnimatePresence, motion } from '../Motion';

import { Overlay } from '../Modal';
import { Box } from '../Rebass';
import Icon from '../Icon';

interface VideoModalProps {
  isOpen: boolean;
  toggleIsOpen: () => void;
  videoUrl: string;
}

const ModalContainer = styled(Box)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const ModalInner = styled(Box)`
  position: relative;
  padding-top: 56.25%;
`;

const StyledPlayer = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
  user-select: none;
`;

const CloseIcon = styled(Box)`
  position: absolute;
  top: -32px;
  right: -32px;
  cursor: pointer;
`;

const AnimatedOverlay = motion.custom(Overlay);

const VideoModal = (props: VideoModalProps) => {
  const { isOpen, toggleIsOpen, videoUrl } = props;

  const handleOverlayClick = (e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault();
    toggleIsOpen();
  };

  const handleContainerClick = (e: React.MouseEvent | React.TouchEvent) => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    // @ts-ignore
    <AnimatePresence initial={false}>
      {isOpen ? (
        <AnimatedOverlay
          data-testid="video-modal-overlay"
          exit={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          sx={{ zIndex: 'videoModal' }}
          onClick={handleOverlayClick}
          onTouchEnd={handleOverlayClick}
        >
          <ModalContainer
            sx={{ width: ['80%', '80%', '60%'] }}
            onClick={handleContainerClick}
            onTouchEnd={handleContainerClick}
          >
            <ModalInner>
              <StyledPlayer
                url={videoUrl}
                playing={isOpen}
                controls={true}
                height="100%"
                width="100%"
                playsinline={true}
                config={{
                  file: {
                    attributes: {
                      playsInline: true,
                      'webkit-playsinline': 'true',
                    },
                  },
                  vimeo: {
                    playerOptions: {
                      playsinline: true,
                      byline: false,
                      portrait: false,
                      title: false,
                    },
                  },
                }}
                muted={false}
                volume={1}
              />
            </ModalInner>
            <CloseIcon
              data-testid="close-modal-icon"
              onClick={handleOverlayClick}
              onTouchEnd={handleOverlayClick}
            >
              <Icon name="close" size={24} sx={{ color: 'textWhite' }} />
            </CloseIcon>
          </ModalContainer>
        </AnimatedOverlay>
      ) : null}
    </AnimatePresence>
  );
};

export default VideoModal;
